"use strict" ;

import '../polyfill/Object'

import ButtonPhase from './components/ButtonPhase'
import isButton    from './components/isButton'

/**
 * The {@link molecule.components} library contains the core components classes that the application uses to build visual displays.
 * @summary The {@link molecule.components} library contains the core components classes that the application uses to build visual displays.
 * @license {@link https://www.mozilla.org/en-US/MPL/2.0/|MPL 2.0} / {@link https://www.gnu.org/licenses/old-licenses/gpl-2.0.fr.html|GPL 2.0} / {@link https://www.gnu.org/licenses/old-licenses/lgpl-2.1.fr.html|LGPL 2.1}
 * @author Marc Alcaraz <ekameleon@gmail.com>
 * @namespace molecule.components
 * @memberof molecule
 */
const components = Object.assign
({
    ButtonPhase : ButtonPhase,
    isButton    : isButton
}) ;

export default components ;